import type { ServerColDef } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';

export const cikColDef: ServerColDef<InvestorFirmFragment> = {
  field: 'cik1',
  headerName: 'CIK',
  initialHide: true,
};
